var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUncateringMealSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 369,
    height: 247,
    viewBox: "0 0 369 247",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9174_47970)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1.34719,
    y: 0.663409,
    width: 364.975,
    height: 245.529,
    rx: 20.5713,
    fill: "#F7F9FF",
    stroke: "#DEE2E6",
    strokeWidth: 1.32718
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.51
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_9174_47970)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M345.753 21.9213H142.504V217.839H345.753V21.9213Z",
    fill: "#DEE2E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.497 25.4726H142.504V214.417H342.497V25.4726Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.015 168.658V111.825H335.109V104.318L321.826 98.1089V90.4183H319.609V111.825H317.401V168.658H314.448V139.138H307.806V123.637H305.589V168.658H300.419V151.686H296.73V147.252H288.616V131.751H284.182V121.42H279.021V105.919H276.804V121.42H271.634V131.751H267.21V147.252H259.087V151.686H255.398V168.658H250.973V147.252H242.85V100.013H240.642V94.8524H222.924V100.013H219.235V133.968H204.47V137.657H199.31V139.874H204.47V153.158H188.979V108.872H186.026V100.013H178.639V66.0678H176.431V100.013H171.261V108.872H142.504V214.416H342.487V168.658H341.015Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.955 111.193H157.867V113.281H159.955V111.193Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.955 114.698H157.867V116.786H159.955V114.698Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.955 128.715H157.867V130.804H159.955V128.715Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.955 132.22H157.867V134.308H159.955V132.22Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.955 135.725H157.867V137.813H159.955V135.725Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.955 146.248H157.867V148.337H159.955V146.248Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.955 149.756H157.867V151.845H159.955V149.756Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.276 125.211H161.188V127.3H163.276V125.211Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.276 128.715H161.188V130.804H163.276V128.715Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.276 132.22H161.188V134.308H163.276V132.22Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.276 135.725H161.188V137.813H163.276V135.725Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.276 139.232H161.188V141.32H163.276V139.232Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.276 146.248H161.188V148.337H163.276V146.248Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.276 149.756H161.188V151.845H163.276V149.756Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.596 111.193H164.508V113.281H166.596V111.193Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.596 114.698H164.508V116.786H166.596V114.698Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.596 118.202H164.508V120.29H166.596V118.202Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.596 121.706H164.508V123.795H166.596V121.706Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.596 125.211H164.508V127.3H166.596V125.211Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.596 128.715H164.508V130.804H166.596V128.715Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.596 132.22H164.508V134.308H166.596V132.22Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.596 135.725H164.508V137.813H166.596V135.725Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.596 139.232H164.508V141.32H166.596V139.232Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.596 142.745H164.508V144.833H166.596V142.745Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.596 149.756H164.508V151.845H166.596V149.756Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.916 111.193H167.828V113.281H169.916V111.193Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.916 114.698H167.828V116.786H169.916V114.698Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.916 118.202H167.828V120.29H169.916V118.202Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.916 121.706H167.828V123.795H169.916V121.706Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.916 125.211H167.828V127.3H169.916V125.211Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.916 128.715H167.828V130.804H169.916V128.715Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.916 132.22H167.828V134.308H169.916V132.22Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.916 163.775H167.828V165.863H169.916V163.775Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.237 111.193H171.148V113.281H173.237V111.193Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.237 114.698H171.148V116.786H173.237V114.698Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.237 118.202H171.148V120.29H173.237V118.202Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.237 121.706H171.148V123.795H173.237V121.706Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.237 125.211H171.148V127.3H173.237V125.211Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.237 128.715H171.148V130.804H173.237V128.715Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.237 132.22H171.148V134.308H173.237V132.22Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.237 135.727H171.148V137.815H173.237V135.727Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.237 156.766H171.148V158.854H173.237V156.766Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.237 160.27H171.148V162.358H173.237V160.27Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.237 163.775H171.148V165.863H173.237V163.775Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.237 167.279H171.148V169.367H173.237V167.279Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.237 181.308H171.148V183.396H173.237V181.308Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.561 111.193H174.473V113.281H176.561V111.193Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.561 114.698H174.473V116.786H176.561V114.698Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.561 118.202H174.473V120.29H176.561V118.202Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.561 121.706H174.473V123.795H176.561V121.706Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.561 125.211H174.473V127.3H176.561V125.211Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.561 128.715H174.473V130.804H176.561V128.715Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.561 132.22H174.473V134.308H176.561V132.22Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.561 135.727H174.473V137.815H176.561V135.727Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.561 139.232H174.473V141.32H176.561V139.232Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.561 142.745H174.473V144.833H176.561V142.745Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.561 153.261H174.473V155.349H176.561V153.261Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.561 156.766H174.473V158.854H176.561V156.766Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.561 160.27H174.473V162.358H176.561V160.27Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.561 163.775H174.473V165.863H176.561V163.775Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.561 167.279H174.473V169.367H176.561V167.279Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.561 181.308H174.473V183.396H176.561V181.308Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.889 111.193H177.801V113.281H179.889V111.193Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.889 114.698H177.801V116.786H179.889V114.698Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.889 118.202H177.801V120.29H179.889V118.202Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.889 121.706H177.801V123.795H179.889V121.706Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.889 125.211H177.801V127.3H179.889V125.211Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.889 128.715H177.801V130.804H179.889V128.715Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.889 132.22H177.801V134.308H179.889V132.22Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.889 135.725H177.801V137.813H179.889V135.725Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.889 139.232H177.801V141.32H179.889V139.232Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.889 142.745H177.801V144.833H179.889V142.745Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.889 146.248H177.801V148.337H179.889V146.248Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.889 149.756H177.801V151.845H179.889V149.756Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.889 153.261H177.801V155.349H179.889V153.261Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.889 156.766H177.801V158.854H179.889V156.766Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.889 160.27H177.801V162.358H179.889V160.27Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.889 163.775H177.801V165.863H179.889V163.775Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.889 167.279H177.801V169.367H179.889V167.279Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.889 170.787H177.801V172.875H179.889V170.787Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.209 111.193H181.121V113.281H183.209V111.193Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.209 114.698H181.121V116.786H183.209V114.698Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.209 118.202H181.121V120.29H183.209V118.202Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.209 121.706H181.121V123.795H183.209V121.706Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.209 125.211H181.121V127.3H183.209V125.211Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.209 128.715H181.121V130.804H183.209V128.715Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.209 132.22H181.121V134.308H183.209V132.22Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.209 135.727H181.121V137.815H183.209V135.727Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.209 139.232H181.121V141.32H183.209V139.232Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.209 142.745H181.121V144.833H183.209V142.745Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.209 153.261H181.121V155.349H183.209V153.261Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.209 156.766H181.121V158.854H183.209V156.766Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.209 160.27H181.121V162.358H183.209V160.27Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.209 163.775H181.121V165.863H183.209V163.775Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.53 111.193H184.441V113.281H186.53V111.193Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.53 114.698H184.441V116.786H186.53V114.698Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.53 118.202H184.441V120.29H186.53V118.202Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.53 121.706H184.441V123.795H186.53V121.706Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.53 125.211H184.441V127.3H186.53V125.211Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.53 128.715H184.441V130.804H186.53V128.715Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.53 132.22H184.441V134.308H186.53V132.22Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.53 135.727H184.441V137.815H186.53V135.727Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.53 139.232H184.441V141.32H186.53V139.232Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.53 142.745H184.441V144.833H186.53V142.745Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.53 153.261H184.441V155.349H186.53V153.261Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.53 156.766H184.441V158.854H186.53V156.766Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.53 160.27H184.441V162.358H186.53V160.27Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.924 102.083H221.836V104.172H223.924V102.083Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.924 105.588H221.836V107.677H223.924V105.588Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.924 109.093H221.836V111.181H223.924V109.093Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.924 112.608H221.836V114.696H223.924V112.608Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.924 116.112H221.836V118.2H223.924V116.112Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.924 119.617H221.836V121.705H223.924V119.617Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.924 123.122H221.836V125.21H223.924V123.122Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.924 126.629H221.836V128.717H223.924V126.629Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.924 137.143H221.836V139.231H223.924V137.143Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.924 140.647H221.836V142.735H223.924V140.647Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.248 102.083H225.16V104.172H227.248V102.083Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.248 105.588H225.16V107.677H227.248V105.588Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.248 109.093H225.16V111.181H227.248V109.093Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.248 112.608H225.16V114.696H227.248V112.608Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.248 116.112H225.16V118.2H227.248V116.112Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.248 119.617H225.16V121.705H227.248V119.617Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.248 123.122H225.16V125.21H227.248V123.122Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.248 126.629H225.16V128.717H227.248V126.629Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.248 140.647H225.16V142.735H227.248V140.647Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.569 102.083H228.48V104.172H230.569V102.083Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.569 105.588H228.48V107.677H230.569V105.588Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.569 109.093H228.48V111.181H230.569V109.093Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.569 112.608H228.48V114.696H230.569V112.608Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.569 116.112H228.48V118.2H230.569V116.112Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.569 119.617H228.48V121.705H230.569V119.617Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.569 123.122H228.48V125.21H230.569V123.122Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.569 126.629H228.48V128.717H230.569V126.629Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.889 102.083H231.801V104.172H233.889V102.083Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.889 105.588H231.801V107.677H233.889V105.588Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.889 109.093H231.801V111.181H233.889V109.093Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.889 112.608H231.801V114.696H233.889V112.608Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.889 116.112H231.801V118.2H233.889V116.112Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.889 119.617H231.801V121.705H233.889V119.617Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.889 126.629H231.801V128.717H233.889V126.629Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.889 130.134H231.801V132.222H233.889V130.134Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.889 140.647H231.801V142.735H233.889V140.647Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.889 144.155H231.801V146.243H233.889V144.155Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.889 147.659H231.801V149.747H233.889V147.659Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.889 151.171H231.801V153.26H233.889V151.171Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.889 154.676H231.801V156.764H233.889V154.676Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.889 158.183H231.801V160.271H233.889V158.183Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.889 161.688H231.801V163.776H233.889V161.688Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.213 102.083H235.125V104.172H237.213V102.083Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.213 105.588H235.125V107.677H237.213V105.588Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.213 109.096H235.125V111.184H237.213V109.096Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.213 112.608H235.125V114.696H237.213V112.608Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.213 116.112H235.125V118.2H237.213V116.112Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.213 119.617H235.125V121.705H237.213V119.617Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.213 130.134H235.125V132.222H237.213V130.134Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.213 133.638H235.125V135.726H237.213V133.638Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.213 137.143H235.125V139.231H237.213V137.143Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.213 140.647H235.125V142.735H237.213V140.647Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.213 144.152H235.125V146.24H237.213V144.152Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.213 147.659H235.125V149.747H237.213V147.659Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.213 151.171H235.125V153.26H237.213V151.171Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.213 154.676H235.125V156.764H237.213V154.676Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.213 158.18H235.125V160.268H237.213V158.18Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.213 161.688H235.125V163.776H237.213V161.688Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.213 165.192H235.125V167.281H237.213V165.192Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.213 172.202H235.125V174.29H237.213V172.202Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.534 102.083H238.445V104.172H240.534V102.083Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.534 105.588H238.445V107.677H240.534V105.588Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.534 109.096H238.445V111.184H240.534V109.096Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.534 112.608H238.445V114.696H240.534V112.608Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.534 116.112H238.445V118.2H240.534V116.112Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.534 119.617H238.445V121.705H240.534V119.617Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.534 130.134H238.445V132.222H240.534V130.134Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.534 133.638H238.445V135.726H240.534V133.638Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.534 137.143H238.445V139.231H240.534V137.143Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.534 140.647H238.445V142.735H240.534V140.647Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.534 151.171H238.445V153.26H240.534V151.171Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.534 154.676H238.445V156.764H240.534V154.676Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.534 158.18H238.445V160.268H240.534V158.18Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.534 161.688H238.445V163.776H240.534V161.688Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.534 165.192H238.445V167.281H240.534V165.192Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.534 172.202H238.445V174.29H240.534V172.202Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.534 175.706H238.445V177.795H240.534V175.706Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.666 134.688H268.578V136.776H270.666V134.688Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.666 138.193H268.578V140.281H270.666V138.193Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.666 141.697H268.578V143.785H270.666V141.697Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.666 145.202H268.578V147.29H270.666V145.202Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.666 148.706H268.578V150.795H270.666V148.706Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.666 152.21H268.578V154.299H270.666V152.21Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.666 155.715H268.578V157.804H270.666V155.715Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.666 166.24H268.578V168.328H270.666V166.24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.666 169.744H268.578V171.832H270.666V169.744Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.666 173.249H268.578V175.337H270.666V173.249Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.987 134.688H271.898V136.776H273.987V134.688Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.987 138.193H271.898V140.281H273.987V138.193Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.987 141.697H271.898V143.785H273.987V141.697Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.987 145.202H271.898V147.29H273.987V145.202Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.987 148.706H271.898V150.795H273.987V148.706Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.987 152.21H271.898V154.299H273.987V152.21Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.987 155.715H271.898V157.804H273.987V155.715Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.311 134.688H275.223V136.776H277.311V134.688Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.311 138.193H275.223V140.281H277.311V138.193Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.311 141.697H275.223V143.785H277.311V141.697Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.311 145.202H275.223V147.29H277.311V145.202Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.311 148.706H275.223V150.795H277.311V148.706Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.311 152.21H275.223V154.299H277.311V152.21Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.311 155.715H275.223V157.804H277.311V155.715Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.631 134.688H278.543V136.776H280.631V134.688Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.631 138.193H278.543V140.281H280.631V138.193Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.631 141.697H278.543V143.785H280.631V141.697Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.631 145.202H278.543V147.29H280.631V145.202Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.631 148.706H278.543V150.795H280.631V148.706Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.631 152.21H278.543V154.299H280.631V152.21Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.631 155.715H278.543V157.804H280.631V155.715Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.631 159.22H278.543V161.308H280.631V159.22Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.631 162.727H278.543V164.816H280.631V162.727Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.631 166.24H278.543V168.328H280.631V166.24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.631 169.745H278.543V171.833H280.631V169.745Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.952 134.688H281.863V136.776H283.952V134.688Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.952 138.193H281.863V140.281H283.952V138.193Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.952 141.697H281.863V143.785H283.952V141.697Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.952 145.202H281.863V147.29H283.952V145.202Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.952 148.706H281.863V150.795H283.952V148.706Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.952 152.21H281.863V154.299H283.952V152.21Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.952 155.715H281.863V157.804H283.952V155.715Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.952 159.22H281.863V161.308H283.952V159.22Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.952 162.727H281.863V164.816H283.952V162.727Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.952 166.24H281.863V168.328H283.952V166.24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.952 169.744H281.863V171.832H283.952V169.744Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.952 173.251H281.863V175.34H283.952V173.251Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.952 183.765H281.863V185.853H283.952V183.765Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.952 187.27H281.863V189.358H283.952V187.27Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.276 134.688H285.188V136.776H287.276V134.688Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.276 138.193H285.188V140.281H287.276V138.193Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.276 141.697H285.188V143.785H287.276V141.697Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.276 152.21H285.188V154.299H287.276V152.21Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.276 155.715H285.188V157.804H287.276V155.715Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.276 159.22H285.188V161.308H287.276V159.22Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.276 162.727H285.188V164.816H287.276V162.727Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.276 166.24H285.188V168.328H287.276V166.24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.276 169.744H285.188V171.832H287.276V169.744Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.276 173.251H285.188V175.34H287.276V173.251Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.276 183.765H285.188V185.853H287.276V183.765Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.276 187.27H285.188V189.358H287.276V187.27Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.276 190.774H285.188V192.862H287.276V190.774Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.084 113.647H319.996V115.736H322.084V113.647Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.084 117.152H319.996V119.241H322.084V117.152Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.084 120.66H319.996V122.748H322.084V120.66Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.084 124.164H319.996V126.252H322.084V124.164Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.084 127.676H319.996V129.764H322.084V127.676Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.084 131.181H319.996V133.269H322.084V131.181Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.084 134.688H319.996V136.776H322.084V134.688Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.084 138.193H319.996V140.281H322.084V138.193Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.084 141.697H319.996V143.785H322.084V141.697Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.084 145.202H319.996V147.29H322.084V145.202Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.084 148.706H319.996V150.795H322.084V148.706Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.084 152.21H319.996V154.299H322.084V152.21Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.084 155.715H319.996V157.804H322.084V155.715Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.084 159.22H319.996V161.308H322.084V159.22Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.084 162.727H319.996V164.816H322.084V162.727Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.084 166.24H319.996V168.328H322.084V166.24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.084 169.744H319.996V171.832H322.084V169.744Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.084 173.251H319.996V175.34H322.084V173.251Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.084 176.756H319.996V178.845H322.084V176.756Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.084 180.261H319.996V182.349H322.084V180.261Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.084 183.765H319.996V185.853H322.084V183.765Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.084 187.27H319.996V189.358H322.084V187.27Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.084 190.774H319.996V192.862H322.084V190.774Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.405 113.647H323.316V115.736H325.405V113.647Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.405 117.155H323.316V119.243H325.405V117.155Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.405 120.66H323.316V122.748H325.405V120.66Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.405 124.164H323.316V126.252H325.405V124.164Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.405 127.676H323.316V129.764H325.405V127.676Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.405 131.183H323.316V133.271H325.405V131.183Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.405 134.688H323.316V136.776H325.405V134.688Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.405 138.193H323.316V140.281H325.405V138.193Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.405 141.697H323.316V143.785H325.405V141.697Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.405 145.202H323.316V147.29H325.405V145.202Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.405 148.706H323.316V150.795H325.405V148.706Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.405 152.21H323.316V154.299H325.405V152.21Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.405 155.715H323.316V157.804H325.405V155.715Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.405 159.22H323.316V161.308H325.405V159.22Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.405 162.727H323.316V164.816H325.405V162.727Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.405 166.24H323.316V168.328H325.405V166.24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.405 169.744H323.316V171.832H325.405V169.744Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.405 173.249H323.316V175.337H325.405V173.249Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.405 176.756H323.316V178.845H325.405V176.756Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.725 113.647H326.637V115.736H328.725V113.647Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.725 117.155H326.637V119.243H328.725V117.155Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.725 120.66H326.637V122.748H328.725V120.66Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.725 124.164H326.637V126.252H328.725V124.164Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.725 127.676H326.637V129.764H328.725V127.676Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.725 131.183H326.637V133.271H328.725V131.183Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.725 134.688H326.637V136.776H328.725V134.688Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.725 138.193H326.637V140.281H328.725V138.193Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.725 141.697H326.637V143.785H328.725V141.697Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.725 145.202H326.637V147.29H328.725V145.202Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.725 148.706H326.637V150.795H328.725V148.706Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.725 152.21H326.637V154.299H328.725V152.21Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.725 155.715H326.637V157.804H328.725V155.715Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.725 159.22H326.637V161.308H328.725V159.22Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.725 162.727H326.637V164.816H328.725V162.727Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.725 166.24H326.637V168.328H328.725V166.24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.725 169.745H326.637V171.833H328.725V169.745Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.725 173.249H326.637V175.337H328.725V173.249Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.725 176.756H326.637V178.845H328.725V176.756Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.049 113.647H329.961V115.736H332.049V113.647Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.049 117.155H329.961V119.243H332.049V117.155Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.049 120.66H329.961V122.748H332.049V120.66Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.049 124.164H329.961V126.252H332.049V124.164Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.049 127.676H329.961V129.764H332.049V127.676Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.049 131.183H329.961V133.271H332.049V131.183Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.049 134.688H329.961V136.776H332.049V134.688Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.049 138.193H329.961V140.281H332.049V138.193Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.049 141.697H329.961V143.785H332.049V141.697Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.049 145.202H329.961V147.29H332.049V145.202Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.049 148.706H329.961V150.795H332.049V148.706Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.049 152.21H329.961V154.299H332.049V152.21Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.049 155.715H329.961V157.804H332.049V155.715Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.049 159.22H329.961V161.308H332.049V159.22Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.049 162.727H329.961V164.816H332.049V162.727Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.369 113.647H333.281V115.736H335.369V113.647Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.369 117.155H333.281V119.243H335.369V117.155Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.369 120.66H333.281V122.748H335.369V120.66Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.369 124.164H333.281V126.252H335.369V124.164Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.369 127.676H333.281V129.764H335.369V127.676Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.369 131.183H333.281V133.271H335.369V131.183Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.369 134.688H333.281V136.776H335.369V134.688Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.369 138.193H333.281V140.281H335.369V138.193Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.369 141.697H333.281V143.785H335.369V141.697Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.369 145.202H333.281V147.29H335.369V145.202Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.369 148.706H333.281V150.795H335.369V148.706Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.369 152.21H333.281V154.299H335.369V152.21Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.369 155.715H333.281V157.804H335.369V155.715Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.69 113.647H336.602V115.736H338.69V113.647Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.69 117.155H336.602V119.243H338.69V117.155Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.69 120.66H336.602V122.748H338.69V120.66Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.69 124.164H336.602V126.252H338.69V124.164Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.69 127.676H336.602V129.764H338.69V127.676Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.69 131.183H336.602V133.271H338.69V131.183Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.69 134.688H336.602V136.776H338.69V134.688Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.69 138.193H336.602V140.281H338.69V138.193Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.69 141.697H336.602V143.785H338.69V141.697Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.69 145.202H336.602V147.29H338.69V145.202Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.69 148.706H336.602V150.795H338.69V148.706Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.69 152.21H336.602V154.299H338.69V152.21Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.83 112.608H142.742V114.696H144.83V112.608Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.83 116.112H142.742V118.2H144.83V116.112Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.83 119.617H142.742V121.705H144.83V119.617Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.83 123.122H142.742V125.21H144.83V123.122Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.83 126.629H142.742V128.717H144.83V126.629Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.83 130.134H142.742V132.222H144.83V130.134Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.83 133.638H142.742V135.726H144.83V133.638Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.83 137.143H142.742V139.231H144.83V137.143Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.83 140.647H142.742V142.735H144.83V140.647Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.83 144.152H142.742V146.24H144.83V144.152Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.83 147.659H142.742V149.747H144.83V147.659Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.83 151.171H142.742V153.26H144.83V151.171Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.83 154.676H142.742V156.764H144.83V154.676Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.83 158.18H142.742V160.268H144.83V158.18Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.83 161.688H142.742V163.776H144.83V161.688Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.83 165.192H142.742V167.281H144.83V165.192Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.83 168.697H142.742V170.785H144.83V168.697Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.83 175.706H142.742V177.795H144.83V175.706Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.83 179.211H142.742V181.299H144.83V179.211Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.83 182.715H142.742V184.804H144.83V182.715Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.83 186.222H142.742V188.31H144.83V186.222Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.83 189.735H142.742V191.823H144.83V189.735Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.151 112.608H146.062V114.696H148.151V112.608Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.151 116.112H146.062V118.2H148.151V116.112Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.151 119.617H146.062V121.705H148.151V119.617Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.151 123.122H146.062V125.21H148.151V123.122Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.151 126.629H146.062V128.717H148.151V126.629Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.151 130.134H146.062V132.222H148.151V130.134Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.151 133.638H146.062V135.726H148.151V133.638Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.151 137.143H146.062V139.231H148.151V137.143Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.151 140.647H146.062V142.735H148.151V140.647Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.151 144.152H146.062V146.24H148.151V144.152Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.151 147.659H146.062V149.747H148.151V147.659Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.151 151.171H146.062V153.26H148.151V151.171Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.151 154.676H146.062V156.764H148.151V154.676Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.151 158.18H146.062V160.268H148.151V158.18Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.151 161.688H146.062V163.776H148.151V161.688Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.151 165.192H146.062V167.281H148.151V165.192Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.151 186.222H146.062V188.31H148.151V186.222Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.151 189.735H146.062V191.823H148.151V189.735Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.471 112.608H149.383V114.696H151.471V112.608Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.471 116.112H149.383V118.2H151.471V116.112Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.471 119.617H149.383V121.705H151.471V119.617Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.471 123.122H149.383V125.21H151.471V123.122Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.471 126.629H149.383V128.717H151.471V126.629Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.471 130.134H149.383V132.222H151.471V130.134Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.471 133.638H149.383V135.726H151.471V133.638Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.471 137.143H149.383V139.231H151.471V137.143Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.471 140.647H149.383V142.735H151.471V140.647Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.471 144.155H149.383V146.243H151.471V144.155Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.471 147.659H149.383V149.747H151.471V147.659Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.471 151.171H149.383V153.26H151.471V151.171Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.471 154.676H149.383V156.764H151.471V154.676Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.471 158.183H149.383V160.271H151.471V158.183Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.471 161.688H149.383V163.776H151.471V161.688Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.471 165.192H149.383V167.281H151.471V165.192Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.471 172.202H149.383V174.29H151.471V172.202Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.471 175.706H149.383V177.795H151.471V175.706Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.471 179.211H149.383V181.299H151.471V179.211Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.471 182.715H149.383V184.804H151.471V182.715Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.471 189.735H149.383V191.823H151.471V189.735Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.409 137.143H207.32V139.231H209.409V137.143Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.409 140.647H207.32V142.735H209.409V140.647Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.409 144.155H207.32V146.243H209.409V144.155Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.409 147.659H207.32V149.747H209.409V147.659Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.409 151.171H207.32V153.26H209.409V151.171Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.409 154.676H207.32V156.764H209.409V154.676Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.409 158.183H207.32V160.271H209.409V158.183Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.409 161.688H207.32V163.776H209.409V161.688Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.409 165.192H207.32V167.281H209.409V165.192Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.409 168.697H207.32V170.785H209.409V168.697Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.409 172.202H207.32V174.29H209.409V172.202Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.409 175.706H207.32V177.795H209.409V175.706Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.409 179.211H207.32V181.299H209.409V179.211Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.409 186.22H207.32V188.308H209.409V186.22Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.409 189.735H207.32V191.823H209.409V189.735Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.409 193.24H207.32V195.328H209.409V193.24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.409 196.745H207.32V198.833H209.409V196.745Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.409 203.756H207.32V205.844H209.409V203.756Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.409 207.26H207.32V209.348H209.409V207.26Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.409 210.765H207.32V212.853H209.409V210.765Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.729 137.143H210.641V139.231H212.729V137.143Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.729 140.647H210.641V142.735H212.729V140.647Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.729 144.155H210.641V146.243H212.729V144.155Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.729 147.659H210.641V149.747H212.729V147.659Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.729 151.171H210.641V153.26H212.729V151.171Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.729 154.676H210.641V156.764H212.729V154.676Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.729 158.183H210.641V160.271H212.729V158.183Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.729 161.688H210.641V163.776H212.729V161.688Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.729 165.192H210.641V167.281H212.729V165.192Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.729 168.697H210.641V170.785H212.729V168.697Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.729 172.202H210.641V174.29H212.729V172.202Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.729 175.706H210.641V177.795H212.729V175.706Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.729 179.211H210.641V181.299H212.729V179.211Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.729 189.735H210.641V191.823H212.729V189.735Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.729 193.24H210.641V195.328H212.729V193.24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.729 200.248H210.641V202.337H212.729V200.248Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.729 203.756H210.641V205.844H212.729V203.756Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.729 207.26H210.641V209.348H212.729V207.26Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.729 210.765H210.641V212.853H212.729V210.765Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.049 137.143H213.961V139.231H216.049V137.143Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.049 140.647H213.961V142.735H216.049V140.647Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.049 144.155H213.961V146.243H216.049V144.155Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.049 147.659H213.961V149.747H216.049V147.659Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.049 151.171H213.961V153.26H216.049V151.171Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.049 154.676H213.961V156.764H216.049V154.676Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.049 158.183H213.961V160.271H216.049V158.183Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.049 161.688H213.961V163.776H216.049V161.688Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.049 165.192H213.961V167.281H216.049V165.192Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.049 168.697H213.961V170.785H216.049V168.697Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.049 172.202H213.961V174.29H216.049V172.202Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.049 175.706H213.961V177.795H216.049V175.706Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.049 179.211H213.961V181.299H216.049V179.211Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.049 182.715H213.961V184.804H216.049V182.715Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.049 189.735H213.961V191.823H216.049V189.735Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.049 196.745H213.961V198.833H216.049V196.745Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.049 200.248H213.961V202.337H216.049V200.248Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.049 203.756H213.961V205.844H216.049V203.756Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.049 207.26H213.961V209.348H216.049V207.26Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.049 210.765H213.961V212.853H216.049V210.765Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.877 157.133H193.789V159.221H195.877V157.133Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.877 160.638H193.789V162.726H195.877V160.638Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.877 164.142H193.789V166.23H195.877V164.142Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.877 167.647H193.789V169.735H195.877V167.647Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.877 171.154H193.789V173.242H195.877V171.154Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.877 174.666H193.789V176.755H195.877V174.666Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.877 185.183H193.789V187.271H195.877V185.183Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.877 188.688H193.789V190.776H195.877V188.688Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.877 192.193H193.789V194.281H195.877V192.193Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.877 195.697H193.789V197.785H195.877V195.697Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.877 199.202H193.789V201.29H195.877V199.202Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.877 202.706H193.789V204.795H195.877V202.706Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.877 206.21H193.789V208.299H195.877V206.21Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.198 157.133H197.109V159.221H199.198V157.133Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.198 160.638H197.109V162.726H199.198V160.638Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.198 164.142H197.109V166.23H199.198V164.142Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.198 167.647H197.109V169.735H199.198V167.647Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.198 171.152H197.109V173.24H199.198V171.152Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.198 174.666H197.109V176.755H199.198V174.666Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.198 185.181H197.109V187.269H199.198V185.181Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.198 188.688H197.109V190.776H199.198V188.688Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.198 192.193H197.109V194.281H199.198V192.193Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.198 195.697H197.109V197.785H199.198V195.697Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.198 199.202H197.109V201.29H199.198V199.202Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.198 202.706H197.109V204.795H199.198V202.706Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.198 209.715H197.109V211.804H199.198V209.715Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.534 141.697H307.445V143.785H309.534V141.697Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.534 145.202H307.445V147.29H309.534V145.202Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.534 148.706H307.445V150.795H309.534V148.706Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.534 152.21H307.445V154.299H309.534V152.21Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.534 155.715H307.445V157.804H309.534V155.715Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.534 159.22H307.445V161.308H309.534V159.22Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.534 162.727H307.445V164.816H309.534V162.727Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.534 166.24H307.445V168.328H309.534V166.24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.534 169.745H307.445V171.833H309.534V169.745Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.534 173.249H307.445V175.337H309.534V173.249Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.534 176.756H307.445V178.845H309.534V176.756Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.534 183.765H307.445V185.853H309.534V183.765Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.534 187.27H307.445V189.358H309.534V187.27Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.534 190.774H307.445V192.862H309.534V190.774Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.534 194.279H307.445V196.367H309.534V194.279Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.534 197.786H307.445V199.874H309.534V197.786Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.534 201.291H307.445V203.379H309.534V201.291Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.534 204.803H307.445V206.891H309.534V204.803Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.534 208.31H307.445V210.398H309.534V208.31Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.858 141.697H310.77V143.785H312.858V141.697Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.858 145.202H310.77V147.29H312.858V145.202Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.858 148.706H310.77V150.795H312.858V148.706Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.858 152.21H310.77V154.299H312.858V152.21Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.858 155.715H310.77V157.804H312.858V155.715Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.858 159.22H310.77V161.308H312.858V159.22Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.858 162.727H310.77V164.816H312.858V162.727Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.858 166.24H310.77V168.328H312.858V166.24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.858 169.744H310.77V171.832H312.858V169.744Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.858 173.249H310.77V175.337H312.858V173.249Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.858 176.756H310.77V178.845H312.858V176.756Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.858 180.261H310.77V182.349H312.858V180.261Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.858 183.765H310.77V185.853H312.858V183.765Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.858 187.27H310.77V189.358H312.858V187.27Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.858 190.774H310.77V192.862H312.858V190.774Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.858 194.279H310.77V196.367H312.858V194.279Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.858 197.786H310.77V199.874H312.858V197.786Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.858 201.291H310.77V203.379H312.858V201.291Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.858 204.803H310.77V206.891H312.858V204.803Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.858 208.31H310.77V210.398H312.858V208.31Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.178 155.347H291.09V157.435H293.178V155.347Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.178 158.852H291.09V160.94H293.178V158.852Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.178 162.359H291.09V164.447H293.178V162.359Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.178 165.864H291.09V167.952H293.178V165.864Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.178 169.376H291.09V171.465H293.178V169.376Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.178 172.88H291.09V174.969H293.178V172.88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.178 176.388H291.09V178.476H293.178V176.388Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.178 179.893H291.09V181.981H293.178V179.893Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.178 183.397H291.09V185.485H293.178V183.397Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.178 186.902H291.09V188.99H293.178V186.902Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.502 155.347H294.414V157.435H296.502V155.347Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.502 158.852H294.414V160.94H296.502V158.852Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.502 162.359H294.414V164.447H296.502V162.359Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.502 165.864H294.414V167.952H296.502V165.864Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.502 169.376H294.414V171.465H296.502V169.376Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.502 172.88H294.414V174.969H296.502V172.88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.502 176.388H294.414V178.476H296.502V176.388Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.502 179.893H294.414V181.981H296.502V179.893Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.502 183.397H294.414V185.485H296.502V183.397Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.166 22.308H274.652V217.839H278.166V22.308Z",
    fill: "#DEE2E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.135 22.308H208.621V217.839H212.135V22.308Z",
    fill: "#DEE2E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.108 22.308H142.594V217.839H146.108V22.308Z",
    fill: "#DEE2E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.0745 45.978C80.2737 45.978 86.1099 40.1418 86.1099 32.9426C86.1099 25.7433 80.2737 19.9072 73.0745 19.9072C65.8752 19.9072 60.0391 25.7433 60.0391 32.9426C60.0391 40.1418 65.8752 45.978 73.0745 45.978Z",
    fill: "#DEE2E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.0773 44.0272C79.1995 44.0272 84.1625 39.0642 84.1625 32.942C84.1625 26.8199 79.1995 21.8569 73.0773 21.8569C66.9552 21.8569 61.9922 26.8199 61.9922 32.942C61.9922 39.0642 66.9552 44.0272 73.0773 44.0272Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.6016 25.3354V33.0812L78.7348 30.1834",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.6016 25.3354V33.0812L78.7348 30.1834",
    stroke: "#DEE2E6",
    strokeWidth: 1.83986,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2759 55.4277L125.926 55.4277V139.562H17.2759V55.4277Z",
    fill: "white",
    stroke: "#F6F7FA",
    strokeWidth: 1.32718
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.59 66.4106H27.125V84.0272H39.59V66.4106Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.8252 71.6078H42.707V90.4664H55.8252V71.6078Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.1 111.7L28.0938 109.99L25.6355 128.687L38.6417 130.397L41.1 111.7Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.0752 109.977H59.957V128.836H73.0752V109.977Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.3994 107.999H44.2812V126.858H57.3994V107.999Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.6257 67.6884H87.4844V75.8298H95.6257V67.6884Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.451 70.1698L99.8477 67.2602L96.938 74.8639L104.542 77.7735L107.451 70.1698Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.5583 68.719C91.5583 68.9858 91.3467 69.1974 91.0799 69.1974C90.8131 69.1974 90.6016 68.9858 90.6016 68.719C90.6016 68.4522 90.8131 68.2407 91.0799 68.2407C91.3467 68.2407 91.5583 68.4522 91.5583 68.719Z",
    fill: "#DEE2E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.925 68.719C100.925 68.9858 100.714 69.1974 100.447 69.1974C100.18 69.1974 99.9688 68.9858 99.9688 68.719C99.9688 68.4522 100.18 68.2407 100.447 68.2407C100.714 68.2407 100.925 68.4522 100.925 68.719Z",
    fill: "#DEE2E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.7458 72.9881C49.7458 73.2548 49.5342 73.4664 49.2674 73.4664C49.0006 73.4664 48.7891 73.2548 48.7891 72.9881C48.7891 72.7213 49.0006 72.5097 49.2674 72.5097C49.5342 72.5097 49.7458 72.7213 49.7458 72.9881Z",
    fill: "#DEE2E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.3651 68.1652C33.6293 68.1652 33.8434 67.951 33.8434 67.6868C33.8434 67.4226 33.6293 67.2084 33.3651 67.2084C33.1009 67.2084 32.8867 67.4226 32.8867 67.6868C32.8867 67.951 33.1009 68.1652 33.3651 68.1652Z",
    fill: "#DEE2E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.3708 111.329C29.3708 111.596 29.1592 111.807 28.8924 111.807C28.6256 111.807 28.4141 111.596 28.4141 111.329C28.4141 111.062 28.6256 110.851 28.8924 110.851C29.1592 110.851 29.3708 111.062 29.3708 111.329Z",
    fill: "#DEE2E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.8416 109.554C51.1058 109.554 51.32 109.34 51.32 109.076C51.32 108.812 51.1058 108.598 50.8416 108.598C50.5775 108.598 50.3633 108.812 50.3633 109.076C50.3633 109.34 50.5775 109.554 50.8416 109.554Z",
    fill: "#DEE2E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.9958 110.863C66.9958 111.129 66.7842 111.341 66.5174 111.341C66.2506 111.341 66.0391 111.129 66.0391 110.863C66.0391 110.596 66.2506 110.384 66.5174 110.384C66.7842 110.384 66.9958 110.596 66.9958 110.863Z",
    fill: "#DEE2E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.737 93.1723H90.6016V109.556H116.737V93.1723Z",
    fill: "#DEE2E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.787 111.809H84.9727V129.821H107.787V111.809Z",
    fill: "#DEE2E6"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M132.305 202.619L121.332 127.47H56.8546L45.88 202.619C45.7464 203.486 45.8007 204.372 46.0394 205.217C46.2781 206.061 46.6955 206.844 47.2634 207.513C47.8313 208.182 48.5364 208.721 49.3308 209.093C50.1252 209.466 50.9905 209.663 51.8678 209.672L89.0922 209.684L126.318 209.672C127.195 209.663 128.06 209.466 128.855 209.093C129.649 208.721 130.354 208.182 130.922 207.513C131.49 206.844 131.907 206.061 132.146 205.217C132.384 204.372 132.439 203.486 132.305 202.619Z",
    fill: "#E1A79C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.0986 209.686L51.8763 209.674C51.0102 209.672 50.1547 209.483 49.3682 209.12C48.5816 208.757 47.8824 208.229 47.318 207.572C46.7385 206.898 46.3108 206.107 46.064 205.253C45.8172 204.399 45.757 203.502 45.8874 202.623L49.9358 174.893C50.5604 175.107 51.2161 175.217 51.8763 175.217L89.0986 175.228L126.325 175.217C126.984 175.217 127.637 175.108 128.26 174.896L132.311 202.624C132.441 203.504 132.381 204.401 132.134 205.255C131.887 206.109 131.46 206.9 130.88 207.574C130.317 208.231 129.618 208.758 128.832 209.121C128.047 209.484 127.192 209.673 126.327 209.676L89.0986 209.686Z",
    fill: "#363A7D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.491 108.829H57.7176C57.2263 108.829 56.8281 109.228 56.8281 109.719V128.635C56.8281 129.127 57.2263 129.525 57.7176 129.525H120.491C120.983 129.525 121.381 129.127 121.381 128.635V109.719C121.381 109.228 120.983 108.829 120.491 108.829Z",
    fill: "#F2BEB4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.658 209.696H126.381C129.614 209.696 132.811 206.567 132.323 203.37L121.329 127.926L108.231 204.542C108.134 205.18 108.175 205.831 108.353 206.451C108.531 207.072 108.841 207.646 109.261 208.136C109.682 208.625 110.203 209.018 110.789 209.287C111.375 209.557 112.013 209.696 112.658 209.696Z",
    fill: "#B57366"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.336 201.035C98.1318 201.035 102.02 197.367 102.02 192.844C102.02 188.32 98.1318 184.652 93.336 184.652C88.5401 184.652 84.6523 188.32 84.6523 192.844C84.6523 197.367 88.5401 201.035 93.336 201.035Z",
    fill: "#D83289"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.414 201.315L235.409 112.322H311.763L324.759 201.315C324.917 202.342 324.853 203.391 324.57 204.39C324.288 205.39 323.793 206.318 323.121 207.11C322.448 207.902 321.613 208.54 320.673 208.981C319.732 209.422 318.707 209.656 317.668 209.666L273.587 209.681L229.504 209.666C228.465 209.656 227.44 209.422 226.5 208.981C225.559 208.54 224.724 207.902 224.051 207.11C223.379 206.318 222.885 205.39 222.602 204.39C222.32 203.391 222.256 202.342 222.414 201.315Z",
    fill: "#E1A79C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.578 209.68L317.657 209.666C318.682 209.663 319.695 209.439 320.627 209.01C321.558 208.58 322.386 207.955 323.055 207.177C323.741 206.379 324.247 205.442 324.54 204.431C324.832 203.42 324.903 202.357 324.749 201.316L319.955 168.478C319.215 168.732 318.438 168.861 317.657 168.862L273.578 168.875L229.493 168.862C228.714 168.862 227.94 168.733 227.202 168.481L222.405 201.317C222.251 202.359 222.322 203.421 222.614 204.433C222.907 205.444 223.413 206.381 224.099 207.179C224.767 207.957 225.594 208.582 226.524 209.011C227.455 209.441 228.467 209.665 229.492 209.668L273.578 209.68Z",
    fill: "#363A7D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.406 90.2469H310.744C311.325 90.2469 311.797 90.7185 311.797 91.3002V113.701C311.797 114.283 311.325 114.755 310.744 114.755H236.406C235.824 114.755 235.353 114.283 235.353 113.701V91.3002C235.353 90.7185 235.824 90.2469 236.406 90.2469Z",
    fill: "#F2BEB4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.681 209.694H229.431C225.601 209.694 221.816 205.989 222.393 202.202L235.413 112.861L250.924 203.591C251.039 204.346 250.99 205.117 250.779 205.852C250.568 206.586 250.202 207.267 249.704 207.846C249.206 208.426 248.589 208.891 247.894 209.21C247.2 209.529 246.445 209.694 245.681 209.694Z",
    fill: "#B57366"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.56 199.437C262.881 199.437 258.277 195.094 258.277 189.737C258.277 184.38 262.881 180.037 268.56 180.037C274.24 180.037 278.844 184.38 278.844 189.737C278.844 195.094 274.24 199.437 268.56 199.437Z",
    fill: "#D83289"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.942 202.619L200.968 127.47H136.491L125.517 202.619C125.383 203.486 125.437 204.372 125.676 205.217C125.915 206.061 126.332 206.844 126.9 207.513C127.468 208.182 128.173 208.721 128.968 209.093C129.762 209.466 130.627 209.663 131.505 209.672L168.729 209.684L205.954 209.672C206.832 209.663 207.697 209.466 208.491 209.093C209.286 208.721 209.991 208.182 210.559 207.513C211.127 206.844 211.544 206.061 211.783 205.217C212.021 204.372 212.075 203.486 211.942 202.619Z",
    fill: "#E1A79C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.739 209.686L131.517 209.674C130.651 209.672 129.795 209.483 129.009 209.12C128.222 208.757 127.523 208.229 126.959 207.572C126.379 206.898 125.951 206.107 125.705 205.253C125.458 204.399 125.398 203.502 125.528 202.623L129.576 174.893C130.201 175.107 130.857 175.217 131.517 175.217L168.739 175.228L205.966 175.217C206.624 175.217 207.278 175.108 207.901 174.896L211.951 202.624C212.082 203.504 212.022 204.401 211.775 205.255C211.528 206.109 211.1 206.9 210.521 207.574C209.957 208.231 209.259 208.758 208.473 209.121C207.687 209.484 206.833 209.673 205.967 209.676L168.739 209.686Z",
    fill: "#363A7D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.124 108.829H137.35C136.859 108.829 136.461 109.228 136.461 109.719V128.635C136.461 129.127 136.859 129.525 137.35 129.525H200.124C200.616 129.525 201.014 129.127 201.014 128.635V109.719C201.014 109.228 200.616 108.829 200.124 108.829Z",
    fill: "#F2BEB4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.291 209.696H206.013C209.247 209.696 212.444 206.567 211.956 203.37L200.962 127.926L187.864 204.542C187.766 205.18 187.808 205.831 187.986 206.451C188.164 207.072 188.474 207.646 188.894 208.136C189.314 208.625 189.836 209.018 190.422 209.287C191.008 209.557 191.646 209.696 192.291 209.696Z",
    fill: "#B57366"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.969 201.035C177.765 201.035 181.652 197.367 181.652 192.844C181.652 188.32 177.765 184.652 172.969 184.652C168.173 184.652 164.285 188.32 164.285 192.844C164.285 197.367 168.173 201.035 172.969 201.035Z",
    fill: "#D83289"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.683594,
    y: 209.695,
    width: 366.303,
    height: 37.1611,
    fill: "#E7EAF1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.889 76.1843C232.889 103.81 210.494 126.205 182.868 126.205C155.243 126.205 132.848 103.81 132.848 76.1843C132.848 48.5586 155.243 26.1636 182.868 26.1636C210.494 26.1636 232.889 48.5586 232.889 76.1843Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.426 83.6527L170.797 98.9868C172.319 100.505 174.84 100.29 176.084 98.5369L210.224 50.3924M232.889 76.1843C232.889 103.81 210.494 126.205 182.868 126.205C155.243 126.205 132.848 103.81 132.848 76.1843C132.848 48.5586 155.243 26.1636 182.868 26.1636C210.494 26.1636 232.889 48.5586 232.889 76.1843Z",
    stroke: "#6ECC83",
    strokeWidth: 7.2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9174_47970"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.683594,
    width: 367.63,
    height: 246.856,
    rx: 21.2349,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_9174_47970"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 329.141,
    height: 197.923,
    fill: "white",
    transform: "translate(16.6094 19.9073)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUncateringMealSuccess);
export default __webpack_public_path__ + "static/media/uncatering-meal-success.5d2c6351fe98db9ff902ea1b778792b0.svg";
export { ForwardRef as ReactComponent };